let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3D7Gx")).then(() => parcelRequire('9RyD0'));